var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLilunkuangjia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16.00000762939453,
    height: 16,
    viewBox: "0 0 16.00000762939453 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_29_01634"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16.00000762939453,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_29_01634)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.0000038146972656,
    y: 2.000000476837158,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#CCCCCC",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.750003814697266,6.750000476837158L14.000003814697266,6.750000476837158L14.000003814697266,5.250000476837158L2.0000038146972656,5.250000476837158L2.0000038146972656,6.750000476837158L5.250003814697266,6.750000476837158L5.250003814697266,14.000000476837158L6.750003814697266,14.000000476837158L6.750003814697266,6.750000476837158Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLilunkuangjia);
export default __webpack_public_path__ + "static/media/lilunkuangjia.f07683945fd3503c70b63cafae20a157.svg";
export { ForwardRef as ReactComponent };